import { SubCategory } from 'types';

const subCategories: SubCategory[] = [
  {
    id: 1,
    name_en: 'IN17',
    name_it: 'IN17',
  },
  {
    id: 2,
    name_en: 'IN17',
    name_it: 'IN17',
  },
];

export { subCategories };
